import {NosotrosImagesContainer} from './NosotrosImagesContainer';
export default NosotrosImagesContainer;